import { createAction } from 'redux-actions';
import { LEFT_PANELS } from 'constants/feature/panel-constants';
import { getTickmarksForRevisionRequest } from 'api/tickmark-api';

const tickmarkListLoaded = createAction('TICKMARK_LIST_LOADED');
const tickmarkListError = createAction('TICKMARK_LIST_ERROR');
const updateTickmarkElementsMapAction = createAction(
  'UPDATE_TICKMARK_ELEMENTS_MAP_ACTION',
);
const updateTickmarkElementsMapFromArrayAction = createAction(
  'UPDATE_TICKMARK_ELEMENTS_MAP_FROM_ARRAY_ACTION',
);

export const updateTickmarkElementsMap =
  ({ response }) =>
  async (dispatch, getState) => {
    if (getState().ui.statementPage.panels.left !== LEFT_PANELS.TICKMARK)
      return;
    const updatedElementsArray = response.data.result
      ? response.data.result.elementEntityList[0]
      : response;
    if (response && updatedElementsArray) {
      dispatch(updateTickmarkElementsMapAction(updatedElementsArray));
    }
  };

export const updateTickmarkElementsMapFromArray =
  ({ elementsArray }) =>
  async (dispatch, getState) => {
    if (getState().ui.statementPage.panels.left !== LEFT_PANELS.TICKMARK)
      return;
    if (elementsArray) {
      dispatch(updateTickmarkElementsMapFromArrayAction(elementsArray));
    }
  };

//duplicate: TO avoid circular dependency
export const fetchTickmarkListForRevisionWithoutLoading =
  ({ revisionId }) =>
  async (dispatch, getState) => {
    if (getState().ui.statementPage.panels.left !== LEFT_PANELS.TICKMARK)
      return;
    try {
      const response = await getTickmarksForRevisionRequest({ revisionId });
      dispatch(tickmarkListLoaded({ response }));
    } catch (error) {
      dispatch(tickmarkListError(error));
    }
  };
